import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=2da29172&scoped=true&"
import script from "./newsletter.vue?vue&type=script&lang=js&"
export * from "./newsletter.vue?vue&type=script&lang=js&"
import style0 from "./newsletter.vue?vue&type=style&index=0&id=2da29172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da29172",
  null
  
)

export default component.exports